import Tabs, { Tab } from "@albertsons/uds/molecule/Tabs";
import LocationItemAsmtTab from "../../common/tab/InterfacesTab/LocationItemAsmtTab";
import "./L2Interfaces.css";
import LocationItemAsmtHistoryTab from "../../common/tab/InterfacesHistory/LocationItemAsmtHistoryTab";
import Header from "@albertsons/uds/molecule/Header";
import React from "react";
const LocationItemAsmt = () => {
  return (
    <div>
      <Header title="Location Item Assignment MA NON PROD DATA Refresh"></Header>

      <div className="col-12 margin-left">
        <Tabs variant="light">
          <Tab>
            <Tab.Header>Location Item Assignment Data Load</Tab.Header>
            <Tab.Content>
              <LocationItemAsmtTab />
            </Tab.Content>
          </Tab>
          <Tab>
            <Tab.Header>Location Item Assignment History</Tab.Header>
            <Tab.Content>
              <LocationItemAsmtHistoryTab />
            </Tab.Content>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default LocationItemAsmt;
